import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { recipesAPI, authAPI } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import RecipeCard from '../common/RecipeCard';
import './Recipes.css';

export default function SearchPage() {
  const { user: currentUser } = useAuth();
  const [tab, setTab] = useState('recipes');
  const [query, setQuery] = useState('');
  const [recipes, setRecipes] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  // Load initial results when tab changes
  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        if (tab === 'recipes') {
          const data = await recipesAPI.getAll({ limit: 20 });
          if (!cancelled) { setRecipes(data.recipes || []); setUsers([]); }
        } else {
          const data = await authAPI.searchUsers({ limit: 10, exclude: currentUser?._id });
          if (!cancelled) { setUsers(data.users || []); setRecipes([]); }
        }
      } catch { /* ignore */ }
      if (!cancelled) setLoading(false);
    })();
    return () => { cancelled = true; };
  }, [tab]);

  const search = useCallback(async () => {
    if (!query.trim()) return;
    setLoading(true);
    try {
      if (tab === 'recipes') {
        const data = await recipesAPI.getAll({ name: query, limit: 20 });
        setRecipes(data.recipes);
        setUsers([]);
      } else {
        const data = await authAPI.searchUsers({ username: query, limit: 20, exclude: currentUser?._id });
        setUsers(data.users);
        setRecipes([]);
      }
    } catch { /* ignore */ }
    setLoading(false);
  }, [query, tab]);

  useEffect(() => {
    if (!query.trim()) return;
    const timer = setTimeout(search, 300);
    return () => clearTimeout(timer);
  }, [search, query]);

  return (
    <div className="search-page">
      <div className="page-header">
        <h1>Search</h1>
      </div>

      <div className="search-tabs">
        <button className={`search-tab ${tab === 'recipes' ? 'active' : ''}`} onClick={() => { setTab('recipes'); setQuery(''); }}>Recipes</button>
        <button className={`search-tab ${tab === 'members' ? 'active' : ''}`} onClick={() => { setTab('members'); setQuery(''); }}>Members</button>
      </div>

      <div className="search-bar">
        <input
          className="input-field"
          placeholder={tab === 'recipes' ? 'Search recipes by name...' : 'Search members by username...'}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      {loading ? (
        <div className="loading-center"><div className="spinner" /></div>
      ) : tab === 'recipes' ? (
        recipes.length > 0 ? (
          <div className="recipe-grid">
            {recipes.map(r => <RecipeCard key={r._id} recipe={r} />)}
          </div>
        ) : recipes.length === 0 && query && <div className="empty-state"><span className="empty-icon">🔍</span><h3>No recipes found</h3></div>
      ) : (
        users.length > 0 ? (
          <div className="user-list">
            {users.map(u => (
              <Link key={u._id} to={`/profile/${u._id}`} className="user-list-item">
                <div className="user-avatar-md">
                  {u.profilePicture ? <img src={u.profilePicture} alt={u.username} /> : u.username[0].toUpperCase()}
                </div>
                <div className="user-info">
                  <h4>{u.username}</h4>
                  <p>{u.about || 'Crunchy member'}</p>
                </div>
              </Link>
            ))}
          </div>
        ) : query && <div className="empty-state"><span className="empty-icon">👤</span><h3>No members found</h3></div>
      )}
    </div>
  );
}
